import React, { Fragment } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default (function (children) {
  return children && /*#__PURE__*/React.isValidElement(children) ? children : ___EmotionJSX(Fragment, null, children);
});